import { UPLOADS_BASE } from "../constants/api";
import { getYoutubeThumbnailUrl } from "./youtubeHelpers";

export const formatArticleDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

export const formatArticleDateParts = (value) => {
  if (!value) return { line1: "—", line2: "" };
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return { line1: value, line2: "" };
  const line1 = d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
  const line2 = String(d.getFullYear());
  return { line1, line2 };
};

export const parseArticleTagLabels = (value) => {
  if (!value) return [];
  return String(value)
    .split(/[\s,]+/)
    .map((t) => t.trim())
    .filter(Boolean)
    .map((t) => (t.startsWith("#") ? t.slice(1) : t));
};

export const formatArticleTags = (value) => {
  if (!value) return [];
  return parseArticleTagLabels(value).map((t) => (t.startsWith("#") ? t : `#${t}`));
};

export const getArticleTabCategories = (articles = []) => {
  const seen = new Set();
  const categories = [];

  articles.forEach((article) => {
    parseArticleTagLabels(article.context_tags).forEach((tag) => {
      const key = tag.toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        categories.push(tag);
      }
    });
  });

  return categories;
};

export const resolveArticleMedicalSpecialty = (article, specialtyNames = []) => {
  if (article.medical_specialty) {
    const fromDoctor = specialtyNames.find(
      (name) => name.toLowerCase() === String(article.medical_specialty).toLowerCase(),
    );
    if (fromDoctor) return fromDoctor;
    if (!specialtyNames.length) return article.medical_specialty;
  }

  const tags = parseArticleTagLabels(article.context_tags).map((tag) => tag.toLowerCase());

  const exactMatch = specialtyNames.find((name) =>
    tags.includes(name.toLowerCase()),
  );
  if (exactMatch) return exactMatch;

  return specialtyNames.find((name) => {
    const normalized = name.toLowerCase().replace(/[^a-z0-9]/g, "");
    return tags.some((tag) => {
      const tagNormalized = tag.replace(/[^a-z0-9]/g, "");
      return tagNormalized.length >= 4 && normalized.startsWith(tagNormalized);
    });
  }) || "";
};

export const articleMatchesCategory = (article, category, specialtyNames = []) => {
  if (!category) return true;
  return resolveArticleMedicalSpecialty(article, specialtyNames) === category;
};

export const formatArticleUploadTime = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const mapArticleToCardProps = (article) => {
  const galleryImages = (article.images || []).map(
    (img) => `${UPLOADS_BASE}/uploads/${img.image_path}`,
  );
  const image = galleryImages[0] || getYoutubeThumbnailUrl(article.media_link) || "";
  const dateParts = formatArticleDateParts(article.publication_date);
  const tagLabels = parseArticleTagLabels(article.context_tags);

  return {
    id: article.news_article_id,
    image,
    uploadTime: formatArticleUploadTime(article.created_on),
    tags: formatArticleTags(article.context_tags),
    categories: tagLabels,
    category: tagLabels[0] || "",
    date: formatArticleDate(article.publication_date),
    dateLine1: dateParts.line1,
    dateLine2: dateParts.line2,
    publicationName: article.publication_name || "",
    title: article.article_title,
    description: article.short_description || "",
    slug: undefined,
  };
};
